import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import M11HelperText from './M11HelperText';
import { selectCurrentUserM11Use } from '../slices/currentUser/currentUserSlice';

const M11SidePanel = ({ isOpen, panelWidth, setPanelWidth }) => {

  const m11User = useSelector(selectCurrentUserM11Use);

  const isResizing = useRef(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  const handleResizeMouseDown = (e) => {
    isResizing.current = true;
    startX.current = e.clientX;
    startWidth.current = panelWidth;
    e.preventDefault();
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing.current) { return; }
      const delta = startX.current - e.clientX;
      const newWidth = Math.max(200, Math.min(window.innerWidth * 0.8, startWidth.current + delta));
      setPanelWidth(newWidth);
    };

    const handleMouseUp = () => {
      isResizing.current = false;
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [setPanelWidth]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="side-panel pagewrapper" style={{ "padding": "4px" }}>
      <div className="resize-handle" onMouseDown={handleResizeMouseDown} />
      <div>
        <M11HelperText sample={m11User === "sample"} />
      </div>
    </div>
  );
};

export default M11SidePanel;